<template lang="pug">
  .component-is-module-enabled(v-if="$isModuleEnabled(module)")
    slot

</template>

<script type="text/babel">
  import {mapState} from 'vuex'

  export default {
    name: 'IsModuleEnabled',
    components: {},
    data: function () {
      return {
        moduleEnabled: false
      }
    },
    mounted() {

    },
    props: {
      module: String,
    },
    computed: {

    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  .component-selection-list-item
    cursor: pointer
</style>



// WEBPACK FOOTER //
// IsModuleEnabled.vue?4d3205de